<template>
<div>
  <v-toolbar class="pr-2 elevation-0 transparent">
    <v-btn to="/dashboard" color="error" icon flat>
      <v-icon>arrow_back</v-icon>
    </v-btn>
    <v-toolbar-title class="ml-0 headline">Manage Courses</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn to="/manage-courses/create" color="primary" depressed small>
      <v-icon class="mr-1" left small>add</v-icon>
      <span>Create</span>
    </v-btn>
  </v-toolbar>

  <v-layout row wrap justify-center>
    <v-flex class="px-3 pb-2" xs12>
      <r-crumbs></r-crumbs>
    </v-flex>
    <v-flex v-if="loading" class="text-xs-center py-5 my-5" xs12>
      <v-progress-circular color="accent" indeterminate></v-progress-circular>
    </v-flex>
    <v-flex v-else class="px-2 pb-2" xs12>
      <v-tabs class="pa-0 ma-0" v-model="activeTab" color="transparent" slider-color="accent" centered>
        <v-tab ripple>Live</v-tab>
        <v-tab ripple>Online</v-tab>
        <v-tab-item>
          <v-layout class="pt-3" row wrap justify-center>
            <v-flex v-if="live.length == 0" class="py-5 my-5 text-xs-center" xs12 sm10 md6>
              <div class="display-2 grey--text text--lighten-1">None</div>
            </v-flex>
            <template v-else>
              <v-flex v-for="c, i in live" :key="i" class="px-3 pb-4" xs12 sm10 md6>
                <r-course :courses="c"></r-course>
              </v-flex>
            </template>
          </v-layout>
        </v-tab-item>
        <v-tab-item>
          <v-layout class="pt-3" row wrap justify-center>
            <v-flex v-if="online.length == 0" class="py-5 my-5 text-xs-center" xs12 sm10 md6>
              <div class="display-2 grey--text text--lighten-1">None</div>
            </v-flex>
            <template v-else>
              <v-flex v-for="c, i in online" :key="i" class="px-3 pb-4" xs12 sm10 md6>
                <r-course :courses="c"></r-course>
              </v-flex>
            </template>
          </v-layout>
        </v-tab-item>
      </v-tabs>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import Crumbs from '../general/Crumbs.vue'
import CourseView from './CourseView.vue'
export default {
  components: {
    rCrumbs: Crumbs,
    rCourse: CourseView
  },
  data: () => ({
    loading: false,
    activeTab: null
  }),
  computed: {
    allCourses () {
      return this.$store.getters.courses
    },
    live () {
      const live = []
      let added = false
      for (let course of this.allCourses) {
        if (course.type === 'Live') {
          for (let group of live) {
            if (group[0].name === course.name) {
              group.push(course)
              added = true
              group.sort((a, b) => {
                return parseInt(a.onlineDays) - parseInt(b.onlineDays)
              })
            }
          }
          if (!added) live.push([course])
          added = false
        }
      }
      live.sort((a, b) => {
        return (new Date(b[0].dates[0])).valueOf() - (new Date(a[0].dates[0])).valueOf()
      })
      return live
    },
    online () {
      const online = []
      let added = false
      for (let course of this.allCourses) {
        if (course.type === 'Online') {
          for (let group of online) {
            if (this.$store.getters.arrayEquals(group[0].content, course.content) && group[0].name.toLowerCase() === course.name.toLowerCase() && group[0].subject === course.subject) {
              group.push(course)
              added = true
              group.sort((a, b) => {
                return parseInt(a.onlineDays) - parseInt(b.onlineDays)
              })
            }
          }
          if (!added) online.push([course])
          added = false
        }
      }
      return online
    }
  },
  beforeMount () {
    this.load()
  },
  methods: {
    load () {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/courses/CourseList.vue